import React from 'react';
import _ from 'lodash';
import { useQuery, useParameterizedQuery } from 'react-fetching-library';
import { Box, Modal, Stack } from '@mui/material';
import { useSelector } from 'react-redux';

import { getDocumentsAction, getInvoiceDocuments } from '../../../services/request';
import { DocumentList } from './document/DocumentList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { DocumentSidebar } from './document/DocumentSidebar';
import { DialogAnimate } from '../../../components/animate';
import { DocumentTypeDialogContent } from './document/DocumentTypeDialogContent';
import { DocumentBase } from '../order/order-details/tabs/SettlementTab/documents/DocumentBase';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';
import { invoiceTypes } from '../../../services/constants';

export const DocumentRecord = () => {
  const { module, season } = useSelector(state => state.app);
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getDocumentsAction(search, 'GET'));
  const { query } = useParameterizedQuery(getInvoiceDocuments);
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [openInvoiceForm, setOpenInvoiceForm] = React.useState(false);
  const [documents, setDocuments] = React.useState([]);
  const [openDocumentTypeChoiceDialog, setOpenDocumentTypeChoiceDialog] = React.useState(false);
  const [orderData, setOrderData] = React.useState([]);
  const [documentType, setDocumentType] = React.useState(null);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [manual, setManual] = React.useState(false);
  const [editData, setEditData] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setDocuments(payload.results);
    }
  }, [loading, search]);


  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const createSignal = (orderData, type, isManual = false) => {
    if (isManual) {
      setManual(true);
    }
    setOpenDocumentTypeChoiceDialog(false);
    setDocumentType(type);
    setOrderData(orderData);
    setOpenInvoiceForm(true);
  };

  const editSignal = (editData, isManual = false) => {
    setOrderData({ id: editData.order });
    if (isManual) {
      setManual(true);
    }
    setOpenDocumentTypeChoiceDialog(false);
    setDocumentType(invoiceTypes.find(x => x.code == editData.type));
    setEditData(editData);
    setOpenInvoiceForm(true);
  };

  const submitCallback = (method, invoice) => {
    if (method === 'create') {
      const docs = _.cloneDeep(documents);
      docs.unshift(invoice);
      setDocuments(docs);
      setSeverity('success');
      setTitle('Dodano dokument');
      setMessage('');
      setShowAlert(true);
      setEditData([]);
    } else if (method === 'edit') {
      const docs = _.cloneDeep(documents);
      const idx = _.findIndex(docs, obj => obj.id == invoice.id);
      docs[idx] = invoice;
      setDocuments(docs);
      setSeverity('success');
      setTitle('Edytowano dokument');
      setMessage('');
      setShowAlert(true);
      setEditData([]);
    }
  };

  const downloadDocumentCallback = async (id, fileName) => {
    const { payload, error, loading } = await query(id);
    if (!error && !loading) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${fileName}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      setSeverity('error');
      setTitle('Nie udało pobrać się pliku.');
      setMessage('');
      setShowAlert(true);
    }
  };

  const updateDocumentListCallback = document => {
    const docs = _.cloneDeep(documents);
    const idx = _.findIndex(docs, obj => obj.id == document.id);
    docs[idx] = document;
    setDocuments(docs);
  };

  const deleteCallback = id => {
    setDocuments(_.filter(documents, obj => obj.id !== id));
  };

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      <Stack direction="row" sx={{ height: 'calc(100% - 24px)' }}>
        { !hideSidebar && (
          <DocumentSidebar
            isOpenSidebar={openSidebar}
            onCloseSidebar={() => setOpenSidebar(false)}
            queryCallback={queryCallback}
            documents={documents}
            openDocumentChoiceSignal={() => setOpenDocumentTypeChoiceDialog(true)}
          />
        )}
        <DocumentList
          sx={{ flex: '1 1 90%' }}
          loading={loading}
          hideSidebar={() => setHideSidebar(!hideSidebar)}
          onOpenSidebar={() => setOpenSidebar(true)}
          documents={documents}
          queryCallback={queryCallback}
          editSignal={editSignal}
          downloadDocumentCallback={downloadDocumentCallback}
          setDocuments={setDocuments}
          updateDocumentListCallback={updateDocumentListCallback}
          deleteCallback={deleteCallback}
        />
        <DialogAnimate open={openDocumentTypeChoiceDialog} onClose={() => setOpenDocumentTypeChoiceDialog(false)} maxWidth="sm">
          <DocumentTypeDialogContent createSignal={createSignal} />
        </DialogAnimate>
      </Stack>
      {documentType && <Modal open={openInvoiceForm} onClose={() => {
        setOpenInvoiceForm(false);
      }} >
        <Box>
          <DocumentBase closeDialog={() => {
            setOpenInvoiceForm(false);
          }} type={documentType} order={orderData} editData={editData} season={season} module={module} submitCallback={submitCallback} manual={manual} />
        </Box>
      </Modal>}
    </>
  );
};
